<template lang="pug">
    .not-found-page
        .not-found-page__title(v-if="title") {{ title }}
        .not-found-page__description(v-if="description" v-html="description")
        re-button(@click="goHome") Go to Homepage
</template>

<script>
export default {
    name: 'not-found',

    computed: {
        title() {
            return this.$route.meta.title
        },
        description() {
            return this.$route.meta.description
        },
    },

    methods: {
        goHome() {
            this.$router.push('/')
        },
    },
}
</script>
